export const ACTION_TYPES = {
  ITEM: "item",
  HEADER: "header",
  SUBMENU: "submenu",
  SEPARATOR: "separator"
};
